const IP = process.env.NODE_ENV === 'production' ? 'api.snbc-connect.com' : '192.168.1.40:8000';
// const IP = "snb-nomu-be.onrender.com"


export default IP;